import { useTranslation } from 'react-i18next';
import formatIDR from 'utils/formatIDR';

const SIZES = {
  sm: 'text-sm',
  md: 'text-[15px]',
  lg: 'text-xl',
};

/**
 * Integer rupiah ("Rp1.000.000"). `compareAt` (the original price) shows a
 * struck-through price and colors the current one with the theme's sale color.
 * `from` prefixes "Mulai" when variants have different prices.
 */
export default function Price({ amount, compareAt, from = false, size = 'md', className = '' }) {
  const { t } = useTranslation();
  const text = formatIDR(amount);
  if (!text) return null;
  const onSale = compareAt > amount;

  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-2 ${SIZES[size]} ${className}`}>
      <span className={`font-semibold tabular-nums ${onSale ? 'text-sale' : 'text-ink'}`}>
        {onSale && <span className="sr-only">{t('price.now')} </span>}
        {from && <span className="font-normal text-muted">{t('price.from')} </span>}
        {text}
      </span>
      {onSale && (
        <s className="text-[0.85em] tabular-nums text-muted">
          <span className="sr-only">{t('price.was')} </span>
          {formatIDR(compareAt)}
        </s>
      )}
    </span>
  );
}

/** Percentage saved, rounded down ("Hemat 12%"), or 0. */
export function discountPercent(amount, compareAt) {
  if (!(compareAt > amount) || !amount) return 0;
  return Math.floor(((compareAt - amount) / compareAt) * 100);
}
